import { elements, modifiers } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { elements as calendarElements } from '../../../styles.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import {
  dateUserFormat,
  timeUserFormat
} from '#components/generics/js/datetime/tools.js'

const { parseInt } = Number
const options = object(null, {
  attributes: true,
  attributeFilter: array(['value']),
})
let endTimeLocked = false

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    input
  ) => {
    endTimeLocked = true
  }
})

export default (wrapper) => {
  const { ownerDocument } = wrapper
  // start
  const startDateDay = one(`.${modifiers.new_field_input.new_hidden}[name*="__day"]`, wrapper)
  const startTimeSec = one(`.${modifiers.new_field_input.new_hidden}[name*="__sec"]`, wrapper)
  // end
  const endDate = one(`.${calendarElements.eventScheduleEndDate}`, wrapper)
  const endDateDay = one(`.${modifiers.new_field_input.new_hidden}[name*="__day"]`, endDate)
  const endDateText = one(`.${modifiers.new_field_input.new_text}[name*="__day_text"]`, endDate)
  const endTime = one(`.${calendarElements.eventScheduleEndTime}`, wrapper)
  const endTimeSec = one(`.${modifiers.new_field_input.new_hidden}[name*="__sec"]`, endTime)
  const endTimeText = one(`.${modifiers.new_field_input.new_text}[name*="__sec_text"]`, endTime)

  queueMicrotask(async () => {
    for await (const { target } of mutations(startDateDay, options, removed(startDateDay))) {
      const { value } = target

      endTimeLocked = false
      endDateDay.value = value
      endDateText.value = dateUserFormat(ownerDocument, value)
    }
  })

  queueMicrotask(async () => {
    for await (const { target } of mutations(startTimeSec, options, removed(startTimeSec))) {
      const { value } = target
      const parsedValue = parseInt(value, 10)
      const newValue = parsedValue < 82800 ? parsedValue + 3600 : value

      if (!endTimeLocked) {
        endTimeSec.value = newValue
        endTimeText.value = timeUserFormat(ownerDocument, newValue)
      }
    }
  })

  queueMicrotask(async () => {
    for await (const { target } of mutations(startDateDay, options, removed(startDateDay))) {
      const { value } = target

      endDateDay.value = value
      endDateText.value = dateUserFormat(ownerDocument, value)
    }
  })

  onInput.listen(endTimeText)
}
